import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LandingPage } from './pages/LandingPage';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (action: string, event: string, params?: any) => void;
    _fbq: any;
  }
}
// Initialize Facebook Pixel
const initFacebookPixel = () => {
  if (typeof window !== 'undefined') {
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '1881241522762351');
    window.fbq('track', 'PageView');
  }
};
// Initialize pixel on load
initFacebookPixel();
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-396">
    <LandingPage data-id="element-397" />
    {/* Facebook Pixel noscript fallback */}
    <noscript data-id="element-398">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1881241522762351&ev=PageView&noscript=1" alt="" data-id="element-399" />
    </noscript>
  </React.StrictMode>);